import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getPettyCashItems = async () => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/petty-cash-item/`);
        return response.data.data;
    } catch (error) {
        console.log("getPettyCashItems - error", error)
        return handleApiError(error)
    }
}

export const getPettyCashItemById = async (data) => {

    try {
        const { pettyCashItemId } = data
        const response = await axios.get(`${REACT_APP_API_URL}/petty-cash-item/${pettyCashItemId}`,data);
        return response.data.data;
    } catch (error) {
        console.log("getPettyCashItemById - error", error)
        return handleApiError(error)
    }
}

export const getPettyCashItemByPettyCashId = async (data) => {

    try {
        const { pettyCashId } = data
        const response = await axios.get(`${REACT_APP_API_URL}/petty-cash-item/${pettyCashId}`,data);
        return response.data.data;
    } catch (error) {
        console.log("getPettyCashItemByPettyCashId - error", error)
        return handleApiError(error)
    }
}

export const postPettyCashItem = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash-item/create`,data);
        return response.data.data;  
    } catch (error) {
        console.log("postPettyCashItem - error", error)
        return handleApiError(error)
    }
}

export const postBulkPettyCashItems = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash-item/add-petty-cash-items`,data);
        return response.data.data;  
    } catch (error) {
        console.log("postBulkPettyCashItems - error", error)
        return handleApiError(error)
    }
}

export const updateBulkPettyCashItem = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/petty-cash-item/bulk-update`, data);
        return response.data.data; 
    } catch (error) {
        console.log("updateBulkPettyCashItem - error", error)
        return handleApiError(error)
    }
}